@if (!hideSigningFieldNote_()) {
	<ui-note
		title="Review and Add Signing Fields"
		[type]="NOTE_INFO_TYPE"
		[callToActionType]="NOTE_CLOSE_TYPE"
		(callToActionClick)="closeFieldNote()"
		[omitCloseLogic]="true"
	>
		<p class="p-sm">
			We've added signature fields to get you started. Review and add more by
			selecting a signer and field type below.
		</p>
	</ui-note>
}
